// Utils
import { isPreEnvironment, isDemoEnvironment } from '@openbank/cf-ui-framework';

const getLoginLink = (): string =>
  isPreEnvironment() || isDemoEnvironment()
    ? `https://login.${window.ENVIRONMENT}.cf.zinia.com`
    : 'https://login.zinia.com';

export { getLoginLink };
